import { z } from "zod";

export const Id = z.string().min(1);
export const IsoDateTime = z.iso.datetime({ offset: true });
export const IsoDate = z.iso.date();

/** Money is always integer cents, excl. VAT unless the field name says otherwise. */
export const Cents = z.number().int();

export const Email = z.email({ message: "Adresse email invalide." });

/** Product rule: ≥ 8 chars with upper, lower, digit and one of @$!%*?&. */
export const PASSWORD_RULE =
  "Au moins 8 caractères, dont une majuscule, une minuscule, un chiffre et un caractère spécial (@ $ ! % * ? &).";
export const Password = z.string().regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).{8,}$/, {
  message:
    "Le mot de passe doit contenir au moins 8 caractères, dont une majuscule, une minuscule, un chiffre et un caractère spécial (@ $ ! % * ? &).",
});

/** E.164 phone, e.g. "+33612345678". */
export const Phone = z.string().regex(/^\+[1-9]\d{6,14}$/, { message: "Numéro de téléphone invalide." });

export const Siret = z.string().regex(/^\d{14}$/, { message: "Ce champ doit contenir 14 chiffres." });

export function paginated<T extends z.ZodType>(item: T) {
  return z.object({
    items: z.array(item),
    total: z.number().int(),
    page: z.number().int(),
    pageSize: z.number().int(),
  });
}

export const PageQuery = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(100).default(25),
});

/** Error body every non-2xx response carries. `fields` maps form field → message. */
export const ApiErrorBody = z.object({
  code: z.string(),
  message: z.string(),
  fields: z.record(z.string(), z.string()).optional(),
  retryAfterSeconds: z.number().int().optional(),
});
export type ApiErrorBody = z.infer<typeof ApiErrorBody>;

export const Ok = z.object({ ok: z.literal(true) });
